import { AGSGateWin } from "integration/schema/ags-gate-win";
import { LineResultBuilder } from "ags/integration/builders/results/line-result-builder";

class LLLineResultBuilder extends LineResultBuilder {
    public filter(response: AGSGateWin): boolean {
        return response.lineNumber !== undefined && response.gate !== true;
    }
}

export default new LLLineResultBuilder();
